
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux'
import Edit2FillIcon from "remixicon-react/Edit2FillIcon";
import toast from "react-hot-toast";
import DeleteBin5FillIcon from "remixicon-react/DeleteBin5FillIcon";
import { deleteArticleList } from "../../../core/actionCreators/articleActionCreator"

export const ArticleStatusPill = (props: { value: any }) => {
  const isTrue = props.value === true || props.value === "true"
  return (
    <span className={`inline-block whitespace-nowrap px-1.5 py-0.5 rounded text-[11px] font-medium border ${isTrue ? "bg-green-100 text-green-800 border-green-200" : "bg-red-100 text-red-800 border-red-200"}`}>
      {isTrue ? "True" : "False"}
    </span>
  )
}

// Timestamps arrive as "2026-05-19 15:00:56.0" — the fractional seconds are noise.
const formatArticleDate = (value: any) => {
  if (!value) return "—"
  return String(value).replace(/\.\d+$/, "")
}

const ArticleListItem = (props: any) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user } = useSelector((s: any) => s.authStore);
  const { data } = props;

  const updateNavigateHandler = (id: any) => {
    navigate(`/article/${id}`);
  };

  const deleteArticleHandler = (id: any) => {
    const isConfirmed = window.confirm('Are you sure want to delete?')
    if (isConfirmed) {
      dispatch(deleteArticleList({ id: id, email: user.email || 'dev@moglix.com' }, () => {
        toast.success("Deleted successfully");
        window.location.reload()
      }))
    }
  };

  if (!data.length) {
    return (
      <tr>
        <td colSpan={10} className="px-4 py-12 text-center text-xs text-gray-500">No articles found.</td>
      </tr>
    )
  }

  return (
    <>
      {data.map((_d: any) => (
        <tr key={_d?.id} className="[&:nth-child(odd)]:bg-[#f7f7f7]">
          <td className="px-4 py-3 text-left text-xs text-[#3F3F3F] font-medium">
            {_d?.id}
          </td>
          <td className="px-4 py-3 text-left text-xs text-[#3F3F3F]">
            {_d?.title}
          </td>
          <td className="px-4 py-3 text-left text-xs text-[#3F3F3F]">
            {_d?.articleAuthorName || "—"}
          </td>
          <td className="px-4 py-3 text-left text-xs text-[#3F3F3F]">
            {_d?.categoryCode || "—"}
          </td>
          <td className="px-4 py-3 text-left text-xs text-[#3F3F3F] break-all">
            {_d?.friendlyUrl}
          </td>
          <td className="px-4 py-3 text-left text-xs text-[#3F3F3F] whitespace-nowrap">
            {formatArticleDate(_d?.modifiedAt)}
          </td>
          <td className="px-4 py-3 text-left text-xs text-[#3F3F3F] whitespace-nowrap">
            {formatArticleDate(_d?.createdAt)}
          </td>
          <td className="px-4 py-3 text-left text-xs text-[#3F3F3F]">
            {_d?.articleType === "article" ? "Online" : "Supplier"}
          </td>
          <td className="px-4 py-3 text-left text-xs text-[#3F3F3F]">
            <ArticleStatusPill value={_d?.status} />
          </td>
          <td className="px-4 py-3">
            <div className="flex items-center gap-3">
              <button
                onClick={() => updateNavigateHandler(_d.id)}
                className="text-blue-600 hover:text-blue-800 transition-colors"
                title="Edit"
              >
                <Edit2FillIcon size={16} />
              </button>
              <button
                onClick={() => deleteArticleHandler(_d.id)}
                className="text-red-600 hover:text-red-800 transition-colors"
                title="Delete"
              >
                <DeleteBin5FillIcon size={16} />
              </button>
            </div>
          </td>
        </tr>
      ))}
    </>
  );
};
export default ArticleListItem;
